import {mergeAttributes, Node} from "@tiptap/core";
import {ReactNodeViewRenderer} from "@tiptap/react";
import PrintoutPageBreakNodeView from "./PrintoutPageBreakNodeView";

// Pagination sizes the empty fill to the page bottom; the node must not measure itself.
export const PrintoutPageBreakNode = Node.create({
    name: "printoutPageBreak",

    group: "block",
    atom: true,
    selectable: true,
    draggable: true,

    parseHTML() {
        return [
            {
                tag: 'div[data-type="printout-page-break"]',
            },
        ];
    },

    renderHTML({HTMLAttributes}) {
        return [
            "div",
            mergeAttributes(HTMLAttributes, {
                "data-type": "printout-page-break",
                class: "printout-rendered-page-break-block",
            }),
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(PrintoutPageBreakNodeView, {
            trackNodeViewPosition: true,
        });
    },
});
